import React, { Component } from 'react'
import axios from 'axios'
import Config from '../../config'
import {isStation, isStationManager} from '../../helpers';

class Section extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      stationName: "",
      currentWheelChanger:null,
      wheelChangers: [],
      assimilateBoxVisible: false
    }

    this.assimilate = this.assimilate.bind(this)
  }

  componentDidMount() {
    axios.get(Config.api.getDomain() + 'crud/wheelchanger/' + Config.api.getWheelChangerId(), Config.api.getConfig())
      .then(res => {
        this.setState({
            stationName: res.data.name,
            currentWheelChanger : res.data
        })
      })
      .catch(error => {
        console.log(error);
      })
    
      this.getWheelChangers()
  }

  getWheelChangers() {
    axios.get(Config.api.getDomain() + 'station/WheelChangers/' + Config.api.getStationId(), Config.api.getConfig())
      .then(res => {
        this.setState({
          wheelChangers: res.data
        })
      })
      .catch(error => {
        console.log(error)
      })
  }

  assimilate() {
    this.setState({ assimilateBoxVisible: !this.state.assimilateBoxVisible })
  }


  changeWheelChanger(e){
    let wheelChangerId = e.target.getAttribute("value");
    Config.api.setWheelChangerId(wheelChangerId);
    window.location.reload();
  }
  
  render() {
    const wheelChangersBox = (
      <div className='wheelchangers-box'>
        {this.state.wheelChangers.map((wheelChanger, key) => {
          return <div key={key} value={wheelChanger.id} onClick={(e)=>this.changeWheelChanger(e)}>{wheelChanger.retailerId +
          " - " + wheelChanger.name +
          " - " + wheelChanger.address +
          " " + wheelChanger.city}</div>
        })}
      </div>
    )

      var wheelChangerTitle=this.state.stationName;
      if (this.state.currentWheelChanger){
          wheelChangerTitle=this.state.currentWheelChanger.retailerId+
              " - "+ this.state.stationName +
              " - "+ this.state.currentWheelChanger.address +
              "  "+ this.state.currentWheelChanger.city;
      }

    return (
      <div id="Section">
          {
              this.state.wheelChangers.length > 1 && (isStationManager() || isStation() || Config.api.getTokenOriginal()) &&
              <span className='wheel-changer-assimilate' onClick={this.assimilate}>
                  {this.state.assimilateBoxVisible && wheelChangersBox}
              </span>
          }
          <span>Skiftesverkstad</span>

          <div className='user-type'>{wheelChangerTitle}</div>


      </div>
    )
  }
}

export default Section;


// WEBPACK FOOTER //
// ./src/components/Section/index.js